import * as React from 'react';
export const MenuCheckboxItemContext = /*#__PURE__*/React.createContext(undefined);
export function useMenuCheckboxItemContext() {
  const context = React.useContext(MenuCheckboxItemContext);
  if (context === undefined) {
    throw new Error('Base UI: MenuCheckboxItemContext is missing. MenuCheckboxItem parts must be placed within <Menu.CheckboxItem>.');
  }
  return context;
}